module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal confirm fade",
    attrs: {
      "id": [_vm.id],
      "role": "dialog",
      "tabindex": "-1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-center"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "confirm-dialog modal-content"
  }, [_c('div', {
    staticClass: "concil-modal-header flex"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.confirmacao'))
    }
  }), _c('div', [_c('button', {
    staticClass: "close",
    staticStyle: {
      "margin-top": "0px !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])])]), _c('div', {
    staticClass: "modal-content confirm-content"
  }, [_vm._t("body"), _c('div', {
    staticClass: "modal-footer confirm-footer"
  }, [_vm._t("footer")], 2)], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bb3b5fcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3b5fcc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/confirmModal/confirmModal.pug
// module id = 1454
// module chunks = 0